var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var loaders = require('../../layout/components/loaders');
var modal = require('../../layout/components/modal');
var measurableModel = require('../../measurable/models/measurable');

var addEquipmentPortModal = Object.create(Model);
var DEFAULT_PORT_POSITION = 'right';
var DEFAULT_PORT_TYPE = 'output';
var DEFAULT_PORT_DIRECTION = 'right';

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});


addEquipmentPortModal.editDialogue = function (equipmentRecord, rightmostNode, options) {
  addEquipmentPortModal.equipmentRecord = equipmentRecord ? equipmentRecord : undefined;
  var initialValues = buildInitialPortFormValues();
  addEquipmentPortModal.form = {};
  addEquipmentPortModal.form.portName = prop(initialValues.name);
  addEquipmentPortModal.form.portPosition = prop(initialValues.position);
  addEquipmentPortModal.form.portDirection = prop(initialValues.direction);
  addEquipmentPortModal.form.portType = prop(initialValues.type);
  addEquipmentPortModal.form.portClass = prop(initialValues.serviceClass);
  addEquipmentPortModal.errors = [];
  measurableModel.getClassTree().then(function () {
    ensureDefaultServiceClass();
    m.redraw();
  }).catch(function () {
    return null;
  });
  

  var submit = function () {
    return measurableModel.getClassTree().catch(function () {
      return null;
    }).then(function () {
      addEquipmentPortModal.errors = [];
      ensureDefaultServiceClass();

      var newPosition = rightmostNode ? rightmostNode.location : {x: -200, y: 0};;
      var newXposition = parseFloat(newPosition.x) + 200;
      var newYposition = parseFloat(newPosition.y);
      var newPositionString = newXposition.toFixed(2) + " " + newYposition.toFixed(2);

      let body = {
        ...equipmentRecord.ports,
      }
      const nextKey = nextPortKey(body);

      let newPort = buildPortPayload({
        name: addEquipmentPortModal.form.portName(),
        position: addEquipmentPortModal.form.portPosition(),
        type: addEquipmentPortModal.form.portType(),
        direction: addEquipmentPortModal.form.portDirection(),
        serviceClass: addEquipmentPortModal.form.portClass(),
        id: nextPortId(body),
        loc: newPositionString
      });
      addEquipmentPortModal.errors = validatePortPayload(newPort);
      if (addEquipmentPortModal.errors.length > 0) {
        m.redraw();
        return Promise.resolve(false);
      }

      body[nextKey.toString()] = newPort;

      return loaders.requestWithLoader(buildPortsUpdateRequest(equipmentRecord, body))
      .then(function (response) {
        key.unbind('enter');
        options && options.submitCallback ? options.submitCallback() : '';
        modal.vm.close();
        m.redraw();
      })
    });
  };


  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title( 'Add Port: ')
  modal.vm.body = addEquipmentPortModal.view,

  modal.vm.buttons([
    {
      label: "Save",
      class: "btn-good",
      func: submit
    }
  ]);
 
  modal.vm.open();
}


addEquipmentPortModal.view = function () {
  return m('form', {role:'form'}, [
    addEquipmentPortModal.errorView(),
    m('label', 'Name:'),
    m('input.form-control.mb2', {
      type:'text',
      oninput: (ev) => addEquipmentPortModal.form.portName(ev.target.value),
      value: addEquipmentPortModal.form.portName()
    }),
    m('label', 'Position:'),
    m('select.mb2', {
      onchange: function(ev) { setPortPosition(ev.target.value); },
      value: addEquipmentPortModal.form.portPosition()
    },[
      m('option', {value: 'center'}, 'Center'),
      m('option', {value: 'left'}, 'Left'),
      m('option', {value: 'right'}, 'Right'),
      m('option', {value: 'top'}, 'Top'),
      m('option', {value: 'bottom'}, 'Bottom')
    ]),
    m('label', 'Type:'),
    m('div.mb2', [
      m('select', {
        onchange: function(ev) { addEquipmentPortModal.form.portType(ev.target.value); },
        value: normalizePortType(addEquipmentPortModal.form.portPosition(), addEquipmentPortModal.form.portType()),
      },[
        addEquipmentPortModal.form.portPosition() == 'center' ? 
          m('option', {value: 'bidirectional'}, 'Bidirectional')
        : 
          [
            m('option', {value: 'input'}, 'Input'),
            m('option', {value: 'output'}, 'Output')

          ]
      ])
    ]),
    m('label', 'Direction:'),
    m('select.mb2', {
      onchange: function(ev) { addEquipmentPortModal.form.portDirection(ev.target.value); },
      value: addEquipmentPortModal.form.portDirection(),
    },[
      m('option', {value: 'right'}, 'Right'),
      m('option', {value: 'left'}, 'Left')
    ]),
    m('label', 'Service:'),
    m('div', [
      m('select', {
        onchange: function(ev) { addEquipmentPortModal.form.portClass(ev.target.value); },
        value: addEquipmentPortModal.form.portClass()
      },[
          (()=>{
            let options = [];
            let level = 0;
            measurableModel.measurableClassTree.categories.map(category => {
              if (!category || !category.name || category.name === 'Overview') return;
              options.push(m('option', {value: category.name}, `${'-'.repeat(level)} ${category.name}`));
              if (category.children && Array.isArray(category.children)) {
                addOptions(category.children, options, level);
              }
            })
            return options;
          })()
      ])
    ]),
  ])
}

function addOptions(childrenArray, options, level) {
  level++;
  childrenArray.map(category => {
    if (!category || !category.name || category.name === 'Overview') return;
    options.push(m('option', {value: category.name}, `${'-'.repeat(level)} ${category.name}`));
    if (category.children && Array.isArray(category.children)) {
      addOptions(category.children, options, level);
    }
  })
}

function findFirstServiceClass(categories) {
  for (let idx = 0; idx < (categories || []).length; idx++) {
    let category = categories[idx];
    if (!category) continue;
    if (category.name && category.name !== 'Overview') return category.name;
    let childClass = findFirstServiceClass(category.children || []);
    if (childClass) return childClass;
  }
  return '';
}

function getDefaultServiceClass() {
  return findFirstServiceClass((measurableModel.measurableClassTree || {}).categories || []);
}

function buildInitialPortFormValues() {
  return {
    name: '',
    position: DEFAULT_PORT_POSITION,
    type: DEFAULT_PORT_TYPE,
    direction: DEFAULT_PORT_DIRECTION,
    serviceClass: getDefaultServiceClass()
  };
}

function normalizePortType(position, type) {
  if (position === 'center') return 'bidirectional';
  return type === 'input' || type === 'output' ? type : DEFAULT_PORT_TYPE;
}

function ensureDefaultServiceClass() {
  if (!addEquipmentPortModal.form || !addEquipmentPortModal.form.portClass) return;
  if (!addEquipmentPortModal.form.portClass()) {
    addEquipmentPortModal.form.portClass(getDefaultServiceClass());
  }
}

function setPortPosition(position) {
  addEquipmentPortModal.form.portPosition(position);
  addEquipmentPortModal.form.portType(normalizePortType(position, addEquipmentPortModal.form.portType()));
}

function nextPortKey(ports) {
  var keys = Object.keys(ports || {})
    .map(Number)
    .filter(Number.isFinite);
  return keys.length > 0 ? Math.max(...keys) + 1 : 0;
}

function nextPortId(ports) {
  var ids = Object.values(ports || {})
    .map(function (port) {
      return Number(port && port.id);
    })
    .filter(Number.isFinite);
  return ids.length > 0 ? Math.max(...ids) + 1 : 1;
}

function buildPortPayload(portData) {
  var serviceClass = portData.serviceClass;
  var position = portData.position || DEFAULT_PORT_POSITION;
  return {
    name: String(portData.name || '').trim(),
    position: position,
    type: normalizePortType(position, portData.type),
    direction: portData.direction || DEFAULT_PORT_DIRECTION,
    serviceClass: serviceClass,
    class: serviceClass,
    id: portData.id,
    loc: portData.loc
  };
}

function validatePortPayload(port) {
  var errors = [];
  if (!port.name) errors.push("Port name can't be blank.");
  if (!port.type) errors.push('Port type is required.');
  if (!port.serviceClass) errors.push('Port service class is required.');
  return errors;
}

function buildPortsUpdateRequest(equipmentRecord, ports) {
  return {
    loader: 'main',
    url: `/api/v1/customequipment/${equipmentRecord['@rid'].slice(1)}/ports`,
    method: 'PUT',
    body: { ports }
  };
}

addEquipmentPortModal._private = {
  buildInitialPortFormValues,
  buildPortPayload,
  buildPortsUpdateRequest,
  findFirstServiceClass,
  nextPortId,
  nextPortKey,
  normalizePortType,
  validatePortPayload
};

module.exports = addEquipmentPortModal;
